import { FocusEventHandler, InputHTMLAttributes } from "react";

export enum SearchFieldType {
  Gray = "gray",
  White = "white",
}

export enum SearchFieldVariant {
  Large = "large",
  Small = "small",
}

export interface SearchFieldProps
  extends Omit<InputHTMLAttributes<HTMLInputElement>, "type"> {
  onClear?: () => void;
  type?: SearchFieldType;
  variant?: SearchFieldVariant;
  clearButtonClassName?: string;
  onBlur?: FocusEventHandler<HTMLInputElement> | undefined;
  onFocus?: FocusEventHandler<HTMLInputElement> | undefined;
  onIconClick?: () => void;
}
